import { FormControl, FormLabel, FormErrorMessage } from '@chakra-ui/form-control';
import { Input } from '@chakra-ui/input';
import { FieldHookConfig, useFormikContext } from 'formik';
import { useFormikField, useFormikServerError } from './hooks/formikIntegration';
import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';

export const FormError = () => {
  const error = useFormikServerError();

  return (
    <FormControl isInvalid={!!error}>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};

export const FormSubmissionButton = (props: ButtonProps) => {
  const form = useFormikContext();

  return <Button {...props} isLoading={form.isSubmitting} />;
};

export const TextInput = ({ label, ...props }: FieldHookConfig<string> & { label: string }) => {
  const [field, message] = useFormikField(props);

  return (
    <FormControl isInvalid={!!message}>
      <FormLabel htmlFor={props.id || props.name}>{label}</FormLabel>
      <Input {...field} placeholder={props.placeholder} />
      <FormErrorMessage>{message}</FormErrorMessage>
    </FormControl>
  );
};
